import Axios from "axios";
import SessionService from "./sessionService";
const sessionService = new SessionService();

/**
 * We are using get for GET method, save for POST method, update for PUT method, remove for DELETE method.
 * As delete is keyword we are using method name as remove.
 */

export enum ApiHandlerEnum {
  SAVE = 1,
  UPDATE = 2,
  GET = 3,
  DELETE = 4,
}

const requestHandler = (request) => {
  request.headers["content-Type"] = "application/json";
  if (sessionService.getAuthToken()) {
    // request.headers["IcmAuthToken"] = sessionService.getAuthToken();
  }
  return request;
};
Axios.interceptors.request.use((request) => requestHandler(request));

/**
 * Executes GET API
 * @param url - Input URL for GET method.
 * @returns {Axios Promise}
 */
export function get(url, callback) {
  return Axios.get(url)
    .then((response) => {
      callback(null, response);
    })
    .catch((error) => {
      handleError(error);
      callback(error, null);
    });
}
let handleError = (error) => {
  if (error && error.response) {
    console.log("In handlde error in API handler", error);
  }
};

export const axiosApi = Axios.create({});
